class DatasetsStore {
  private static instance: DatasetsStore | null = null;
  private services: Map<string, any> = new Map();

  public static getInstance(): DatasetsStore {
    if (!DatasetsStore.instance) {
      DatasetsStore.instance = new DatasetsStore();
    }
    return DatasetsStore.instance;
  }

  public register(name: string, service: any): void {
    this.services.set(name, service);
  }

  public resolve(name: string): any {
    return this.services.get(name);
  }
}

const datasetsStore = DatasetsStore.getInstance();

export default datasetsStore;
